function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _classPrivateFieldInitSpec(e, t, a) { _checkPrivateRedeclaration(e, t), t.set(e, a); }
function _checkPrivateRedeclaration(e, t) { if (t.has(e)) throw new TypeError("Cannot initialize the same private elements twice on an object"); }
function _classPrivateFieldSet(s, a, r) { return s.set(_assertClassBrand(s, a), r), r; }
function _classPrivateFieldGet(s, a) { return s.get(_assertClassBrand(s, a)); }
function _assertClassBrand(e, t, n) { if ("function" == typeof e ? e === t : e.has(t)) return arguments.length < 3 ? t : n; throw new TypeError("Private element is not present on this object"); }
var _observer = /*#__PURE__*/new WeakMap();
export var SlotRenderObserver = /*#__PURE__*/function () {
  function SlotRenderObserver() {
    _classCallCheck(this, SlotRenderObserver);
    _classPrivateFieldInitSpec(this, _observer, void 0);
  }
  return _createClass(SlotRenderObserver, [{
    key: "observe",
    value: function observe(targetNode, _ref) {
      var onSlotReady = _ref.onSlotReady;
      if (_classPrivateFieldGet(_observer, this)) {
        throw new Error('SlotRenderObserver instance is already observing a node. You have to create new instance to observer an other');
      }
      if (_classPrivateFieldGet(_observer, this) === null) {
        throw new Error('SlotRenderObserver  disconnected to create new observer create a new instance');
      }
      if (!onSlotReady) {
        throw new Error('SlotRenderObserver has to receive onSlotReady callback');
      }
      var status = {
        hasAddedNodes: false,
        hasTextOrOpticNodes: false,
        isAnyChildVisible: false,
        hasForcedBlockRemovingNode: false
      };
      _classPrivateFieldSet(_observer, this, new MutationObserver(function (mutationsList) {
        if (!status.hasAddedNodes) {
          status.hasAddedNodes = !!mutationsList.find(function (mutation) {
            return mutation.addedNodes.length;
          });
        }

        // if we have rendered MS to DOM but meaningful content isn't rendered, e.g. due to essential data preload
        if (!status.hasTextOrOpticNodes) {
          var hasText = !!targetNode.innerText.trim().length;
          var hasOpticNodes = !!targetNode.querySelector(':not(div):not(span)');
          status.hasTextOrOpticNodes = hasText || hasOpticNodes;
        }

        // if we have rendered MS to DOM but temporary hide it for some reason, e.g. to fetch data
        if (!status.isAnyChildVisible) {
          status.isAnyChildVisible = Array.from(targetNode.children).some(function (node) {
            return node.style.display !== 'none';
          });
        }
        if (!status.hasForcedBlockRemovingNodes) {
          status.hasForcedBlockRemovingNode = !!targetNode.querySelector('[data-ilc-slot-ready="true"]');
        }
        if (status.hasAddedNodes && status.hasTextOrOpticNodes && status.isAnyChildVisible || status.hasForcedBlockRemovingNode) {
          onSlotReady();
        }
      }));
      _classPrivateFieldGet(_observer, this).observe(targetNode, {
        childList: true,
        subtree: true,
        attributeFilter: ['style', 'data-ilc-slot-ready']
      });
    }
  }, {
    key: "disconnect",
    value: function disconnect() {
      if (!_classPrivateFieldGet(_observer, this)) {
        //@todo report unexpected disconnection flow
        return;
      }
      _classPrivateFieldGet(_observer, this).disconnect();
      _classPrivateFieldSet(_observer, this, null);
    }
  }]);
}();